export default function IconChecklist() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M2.75 14a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75Zm.75 1.5H5V17H3.5Zm-.75-8a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75ZM3.5 9H5v1.5H3.5Zm2.694-7.13a.75.75 0 0 0-1.047.161L3.782 3.887l-.508-.493a.75.75 0 0 0-1.047 1.077l1.125 1.091a.75.75 0 0 0 1.127-.093l1.875-2.55a.75.75 0 0 0-.16-1.048M8.75 3a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5zm0 6.25a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5Zm0 6.25a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5z"
      />
    </svg>
  );
}
